<app-plain-toolbar></app-plain-toolbar>

<div class="hmn-width__full hmn-height__full hmn-background__primary hmn-row">
  <div class="hmn-margin__auto hmn-form__standalone hmn-padding__x4">
    <h3 class="hmn-margin__x2-bottom">{{ 'AUTH.WELCOME_MESSAGE' | translate }}</h3>
    <h5 class="hmn-margin__x8-bottom hmn-color__primary-800">{{ 'AUTH.SIGNUP_SUBTITLE' | translate }}</h5>

    <app-auth-signup-form></app-auth-signup-form>
  </div>
</div>

<app-plain-footer></app-plain-footer>
